import { render } from "./ServiceDatatableFormComplexServiceServices.vue?vue&type=template&id=be5b705a"
import script from "./ServiceDatatableFormComplexServiceServices.vue?vue&type=script&lang=js"
export * from "./ServiceDatatableFormComplexServiceServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__